import React from 'react';

/** กล่องพื้นเทาที่ใช้ห่อบล็อกย่อยในหน้าเอกสาร (Base URL / Headers / ฟอร์ม playground ฯลฯ) */
const Panel: React.FC<{ className?: string; children: React.ReactNode }> = ({ className = '', children }) => (
  <div className={`bg-gray-50 dark:bg-slate-700/40 rounded-xl p-5 mb-6 border border-gray-200/50 dark:border-slate-700 ${className}`.trim()}>
    {children}
  </div>
);

export default Panel;
